import { Injectable } from '@angular/core';
import {
  NgbDateParserFormatter,
  NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';
import { TranslationService } from 'src/app/modules/i18n/translation.service';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  constructor(private translationService: TranslationService) {
    super();
  }

  format(date: NgbDateStruct | null): string {
    if (!date) return '';
    return `${this.pad(date.day)}.${this.pad(date.month)}.${date.year}`;
  }

  parse(value: string): NgbDateStruct | null {
    if (!value) return null;
    const parts = value.trim().split('.');
    if (parts.length !== 3) return null;
    const [d, m, y] = parts.map((p) => parseInt(p, 10));
    if (!d || !m || !y) return null;
    if (m < 1 || m > 12) return null;
    if (d < 1 || d > 31) return null;
    return { day: d, month: m, year: y };
  }

  private pad(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }
}
